import React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import Store from "./components/Store";
import Navbar from "./components/Navbar";
import Ft from "./components/Ft";
import Home from "./pages/Home";
import Charts from "./pages/Charts";
import LunarPhases from "./pages/LunarPhases";
import YTVideos from "./pages/YTVideos";
import NewChart from "./pages/NewChart";
import Register from "./pages/Register";
import TLEdit from "./pages/TLEdit";
import Rectify from "./pages/Rectify";
import AIInterps from "./pages/AIInterps";
import TLEvents from "./pages/TLEvents";
import TLBook from "./pages/TLBook";
import SunMoon from "./pages/SunMoon";
import Moon from "./pages/Moon";
import LPhaseLookup from "./pages/LPhaseLookup";
import BookReading from "./pages/BookReading";
//import aiLPhase from "./pages/aiLPhase";
//import EmailContactForm from "./pages/EmailContactForm";
import LogIn from "./pages/LogIn";
import About from "./pages/About";
import HowTo from "./pages/HowTo";
import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";

/*
const NavigationPersist = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    localStorage.setItem('lastPath', location.pathname);
  }, [location]);

  React.useEffect(() => {
    const savedPath = localStorage.getItem('lastPath');
    if (savedPath && savedPath !== '/' && location.pathname === '/') {
      navigate(savedPath, { replace: true });
    }
  }, []);

React.useEffect(() => {
  console.log('Current path:', location.pathname);
  console.log('Saved path:', localStorage.getItem('lastPath'));
  localStorage.setItem('lastPath', location.pathname);
}, [location]);

  return null;
};

const AppLayout = () => (
  <>
    <Store>
    <Navbar />
    <NavigationPersist />
    <Outlet />
    <Ft />
    </Store>
  </>
);
*/
const AppLayout = () => (
  <>
    <Store>
    <Navbar />
    <Outlet />
    <Ft />
    </Store>
  </>
);
/*
      {
        path: "bookreading",
        element: <BookReading />,
      },
*/
const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "charts",
        element: <Charts />,
      },
      {
        path: "newchart",
        element: <NewChart />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "tledit",
        element: <TLEdit />,
      },
      {
        path: "rectify",
        element: <Rectify />,
      },
      {
        path: "aiinterps",
        element: <AIInterps />,
      },
      {
        path: "tlevents",
        element: <TLEvents />,
      },
      {
        path: "tlbook",
        element: <TLBook />,
      },
      {
        path: "moon",
        element: <Moon />,
      },
      {
        path: "sunmoon",
        element: <SunMoon />,
      },
      {
        path: "lphaselookup",
        element: <LPhaseLookup />,
      },
      {
        path: "ytvideos",
        element: <YTVideos />,
      },
      {
        path: "lphases",
        element: <LunarPhases />,
      },
      {
        path: "login",
        element: <LogIn />,
      },
      {
        path: "howto",
        element: <HowTo />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "bookreading",
        element: <Home />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);
